import { SearchResults } from "@/core/models/results";
import { Fragment, FunctionalComponent, h } from "@stencil/core";
import {
  EQUIVALENT_EMISSIONS,
  EQUIVALENT_OFFSET,
  EquivalentResourcesRate,
} from "@/components/internal/result/equivalent-resources-rates";
import { theme } from "@/utils/theme";
import { getResourceIcon } from "@/components/internal/result/equivalents-resource-icons";

interface EquivalentsBoxComponentProps {
  results: SearchResults;
}

function renderMessage(
  resource: EquivalentResourcesRate,
  emissionsTotal: number,
) {
  if (resource.title) {
    return (
      <Fragment>
        <div class={"results-equivalents__resource row"}>
          <div
            class="results-equivalents__icon col-icon"
            style={theme.getIconStyle()}
          >
            {getResourceIcon(resource.icon)}
          </div>
          <div class="results-equivalents__value col-value">
            {calculateResourceFootprint(emissionsTotal, resource.rate)}
          </div>
          <div class={"results-equivalents__value-title col-title"}>
            {resource.title}
          </div>
        </div>
        <div class={"results-equivalents__resource row mt-0"}>
          <div class={"results-equivalents__value-message col-message mt"}>
            {resource.message}
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <div class={"results-equivalents__resource"}>
      <div
        class="results-equivalents__icon col-icon"
        style={theme.getIconStyle()}
      >
        {getResourceIcon(resource.icon)}
      </div>
      <div class="results-equivalents__value col-value">
        {calculateResourceFootprint(emissionsTotal, resource.rate)}
      </div>
      <div class={"results-equivalents__value-message col-message ml-1"}>
        {resource.message}
      </div>
    </div>
  );
}

function calculateResourceFootprint(emissionsTotal: number, rate: number) {
  return (emissionsTotal * rate).toLocaleString(window.navigator.language, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}

function renderEquivalentValues(
  results: SearchResults,
  equivalentResourcesRates: EquivalentResourcesRate[],
) {
  if (results && results.emissionsTotal) {
    return Object.entries(equivalentResourcesRates).map(([_, resource]) =>
      renderMessage(resource, results.emissionsTotal),
    );
  }
}

export const EquivalentsBoxComponent: FunctionalComponent<
  EquivalentsBoxComponentProps
> = ({ results }) => (
  <Fragment>
    <div class="row no-spacing">
      <div class={"col-8 "}>
        <div class={"results-equivalents__header"}>
          Carbon Emissions Equivalents
        </div>
        <div class={"results-equivalents__content"}>
          <div class={"results-equivalents__subtitle"}>
            Your flight emissions above are equivalent to:
          </div>
          {renderEquivalentValues(results, EQUIVALENT_EMISSIONS)}
          <div class={"results-equivalents__subtitle"}>
            Your flight emissions above are offset by:
          </div>
          {renderEquivalentValues(results, EQUIVALENT_OFFSET)}
        </div>
      </div>
    </div>
  </Fragment>
);
